import * as React from "react";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  Container,
  Slide,
  Dialog,
  DialogTitle,
  Box,
  Grid,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
} from "@mui/material";
import loader from "../Assets/loader.gif";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function QuizDialog({
  open,
  setOpen,
  handleQuizSubmit,
  resourceData,
}) {
  const [displayImg, setDisplayImg] = React.useState(true);
  let quizResponses = {};

  const handleClose = () => {
    setOpen(false);
    if (resourceData.type !== "QUIZ") {
      setDisplayImg(true);
    }
  };

  const handleOptionChange = (e, ques) => {
    const qid = ques["qid"];
    const optionSelected = e.target.defaultValue;
    quizResponses[qid] = optionSelected;
  };

  React.useEffect(() => {
    quizResponses = {};
    if (resourceData.type === "QUIZ") {
      setDisplayImg(false);
    } else {
      setDisplayImg(true);
    }
  }, [resourceData]);

  return (
    <div>
      <BootstrapDialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        aria-labelledby="customized-dialog-title"
      >
        <Container
          maxWidth="lg"
          style={{
            height: "100vh",
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 500,
              fontSize: "200%",
              textAlign: "center",
              textDecoration: "underline",
            }}
            id="customized-dialog-title"
          >
            {resourceData.title}
          </DialogTitle>

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[1000],
            }}
          >
            <CloseIcon />
          </IconButton>

          <div
            style={{
              display: displayImg ? "" : "none",
              textAlign: "center",
              width: "50%",
              margin: "auto",
            }}
          >
            <img src={loader} width={"100%"} />
          </div>

          {resourceData.link && (
            <iframe
              allowFullScreen
              src={resourceData.link}
              title={resourceData.title}
              onLoad={() => setDisplayImg(false)}
              style={{
                display: displayImg ? "none" : "",
                border: "none",
                overflow: "hidden",
                width: "100%",
                height: "80%",
              }}
            />
          )}
          {resourceData.link && (
            <p style={{ textAlign: "center" }}>
              <a href={resourceData.link} target="_blank">
                If you are not able to access, click here.
              </a>
            </p>
          )}

          {resourceData.quesdata && (
            <Box>
              <Grid container>
                {resourceData.quesdata.map((ques) => (
                  <Grid
                    container
                    item
                    xs={12}
                    md={12}
                    sx={{
                      padding: "4%",
                      margin: "1rem",
                      borderRadius: "0.5rem",
                      boxShadow:
                        " rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px",
                    }}
                    justifyContent="space-evenly"
                  >
                    <Grid item xs={12} md={12}>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "large",
                        }}
                      >
                        {ques.question}
                      </Typography>
                      <br />
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        style={{
                          justifyContent: "space-between",
                        }}
                        onChange={(e) => handleOptionChange(e, ques)}
                      >
                        {ques.options.map((option) => (
                          <FormControlLabel
                            value={option}
                            label={
                              <Typography
                                style={{
                                  fontWeight:
                                    ques?.answer === option ? 700 : "",
                                  color: ques?.answer === option ? "green" : "",
                                }}
                              >
                                {option}
                              </Typography>
                            }
                            control={
                              <Radio
                                checked={
                                  resourceData.userResponses &&
                                  ques.qid in resourceData.userResponses &&
                                  resourceData.userResponses[ques.qid] ===
                                    option
                                }
                              />
                            }
                          />
                        ))}
                      </RadioGroup>
                      <br />
                      {ques.explanation && (
                        <Typography>{ques.explanation}</Typography>
                      )}
                    </Grid>
                  </Grid>
                ))}
              </Grid>

              <Box textAlign="center">
                {resourceData?.userResponses ? (
                  <>
                    <Button
                      variant="contained"
                      sx={{
                        background: "green",
                        margin: "2rem 1rem",
                        width: "35%",
                      }}
                    >
                      Score - {resourceData.score}
                    </Button>
                  </>
                ) : (
                  <Button
                    variant="contained"
                    sx={{
                      background: "#2C6DE7",
                      margin: "2rem 1rem",
                      width: "25%",
                    }}
                    onClick={() => handleQuizSubmit(quizResponses)}
                  >
                    Submit
                  </Button>
                )}
              </Box>
            </Box>
          )}
        </Container>
      </BootstrapDialog>
    </div>
  );
}
